﻿import { echartSetOption } from './echarts-utils';

/* -------------------------------------------------------------------------- */
/*     Driver file Status Summary Chart
/* -------------------------------------------------------------------------- */

const driverFileSummaryInit = () => {
  const { getColor, getData } = window.phoenix.utils;
  const chartEl = document.querySelector('.echart-driver-file');

  if (chartEl) {
    const userOptions = getData(chartEl, 'echarts');
    const chart = window.echarts.init(chartEl);

    const getDefaultOptions = () => ({
      color: [getColor('success'), getColor('warning'), getColor('danger')],

      tooltip: {
        trigger: 'item',
        padding: [7, 10],
        backgroundColor: getColor('body-highlight-bg'),
        borderColor: getColor('border-color'),
        textStyle: { color: getColor('light-text-emphasis') },
        borderWidth: 1,
        transitionDuration: 0,
        position(pos, params, el, elRect, size) {
          const obj = { top: pos[1] - 35 }; // set tooltip position over 35px from pointer
          if (window.innerWidth > 540) {
            if (pos[0] <= size.viewSize[0] / 2) {
              obj.left = pos[0] + 20; // 'move in right';
            } else {
              obj.left = pos[0] - size.contentSize[0] - 20;
            }
          } else {
            obj[pos[0] < size.viewSize[0] / 2 ? 'left' : 'right'] = 0;
          }
          return obj;
        },
        formatter: params => {
          return `<strong>${params.name}:</strong> ${params.value}`;
        },
        extraCssText: 'z-index: 1000'
      },

      legend: { show: false },

      series: [
        {
          name: '',
          type: 'pie',
          radius: ['60%', '90%'],
          avoidLabelOverlap: false,
          emphasis: {
            label: {
              show: false
            }
          },
          itemStyle: {
            borderWidth: 2,
            borderColor: getColor('body-bg')
          },
          label: {
            show: false,
            position: 'center'
          }
        }
      ]
    });

    echartSetOption(chart, userOptions, getDefaultOptions);

    if (window.chartReadyCallback) {
      window.chartReadyCallback(chart);
    }
  }
};

export default driverFileSummaryInit;
